import React from 'react';
import {Link as RouterLink, useLocation} from "react-router-dom";
import Link from '@mui/material/Link';
import ListItemButton from "@mui/material/ListItemButton";
import {ListItemIcon} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {alpha, useTheme} from "@mui/material/styles";
import CircleIcon from '@mui/icons-material/Circle';
import {useJumboLayoutSidebar} from "@jumbo/hooks";
import {SIDEBAR_VIEWS} from "@jumbo/utils/constants/layout";
import {useTranslation} from "react-i18next";
import { ACCESS, ACCESS_SECTIONS } from '../../../app/utils/constants/access';

const menuBefore = {
    left: 0,
    top: 0,
    content: `''`,
    position: 'absolute',
    display: 'inline-block',
    width: '4px',
    height: '100%',
    backgroundColor: 'transparent'
}

const JumboNavItem = ({item, isNested, translate}) => {
    const location = useLocation();
    const {sidebarOptions} = useJumboLayoutSidebar();
    const {t} = useTranslation();
    const theme = useTheme();

    const navPalette = React.useMemo(() => {
        const fallback = {
            action: {active: '#7352C7', hover: '#7352C7'},
            background: {active: alpha('#7352C7', .15), hover: '#E9ECEF'},
            tick: {active: '#7352C7', hover: '#ADB5BD'},
        };
        const base = theme?.palette?.nav || {};
        return {
            action: {...fallback.action, ...(base.action || {})},
            background: {...fallback.background, ...(base.background || {})},
            tick: {...fallback.tick, ...(base.tick || {})},
        };
    }, [theme]);

    const isMiniAndClosed = React.useMemo(() => {
        return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
    }, [sidebarOptions.view, sidebarOptions.open]);

    const label = React.useMemo(() => {
        return translate ? t(item.label) : item.label;
    }, [item, translate, t]);

    if (!item) return null;
    var colorObj = {};
    if(item.access){
        if(item.access.value===ACCESS.MASTER) {
            colorObj = {color: 'red'};

        } else if(item.access.key===ACCESS_SECTIONS.NEWFEATURE) {
            colorObj = {color: 'blue'};
        }
    }
    return (
        <ListItemButton
            component={"li"}
            sx={{
                p: 0,
                ...colorObj,
                overflow: 'hidden',
                borderRadius: isMiniAndClosed ? '50%' : '0 24px 24px 0',
                margin: isMiniAndClosed ? '0 auto' : '0',
                ...(isMiniAndClosed) ? {width: 40, height: 40, justifyContent: 'center'} : {},
                ...(!isMiniAndClosed) ? {'&::before': menuBefore} : {},
                '&:hover': {
                    color: navPalette.action.hover,
                    backgroundColor: navPalette.background.hover,
                    ...(!isMiniAndClosed) ? {'&::before': {
                            ...menuBefore,
                            backgroundColor: navPalette.tick.hover,
                        }} : {}
                },
                ...(location.pathname === item.uri) ? {
                    color: navPalette.action.active,
                    backgroundColor: alpha(navPalette.background.active, .15),
                    ...(!isMiniAndClosed) ? {'&::before': {
                        ...menuBefore,
                            backgroundColor: navPalette.tick.active,
                    }}: {},
                } : {},
            }}
        >
            <Link underline={"none"} component={RouterLink} {...(item.onClick?item.onClick:{ }) } to={item.uri} {...(item.target ? {target: item.target} : {})}
                  sx={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      overflow: "hidden",
                      position: "relative",
                      color: 'inherit',
                      p: theme => !isMiniAndClosed ? theme.spacing(1, 3.75) : 0,
                      ...(isMiniAndClosed) ? {justifyContent: 'center'} : {},
                  }}
            >

                <ListItemIcon sx={{minWidth: isMiniAndClosed ? 20 : 32, color: 'inherit'}}>
                    {
                        isNested ?
                            <CircleIcon sx={{fontSize: 6, ml: 1}}/>
                            :
                            item.icon
                    }
                </ListItemIcon>
                {
                    !isMiniAndClosed &&
                    <ListItemText
                        primary={label}
                        sx={{
                            m: 0,
                            '& .MuiTypography-root': {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }
                        }}
                    />
                }
            </Link>
        </ListItemButton>
    );
};

export default JumboNavItem;
